import React, { createContext, useContext } from 'react';
import { UserResponse } from '../Model/User';

const UserContext = createContext<UserResponse | null>(null);

export const UserProvider: React.FC<{ user: UserResponse | null; children: React.ReactNode }> = ({ user, children }) => (
  <UserContext.Provider value={user}>{children}</UserContext.Provider>
);

export const useUser = () => useContext(UserContext);